import { useState, useRef, useCallback } from 'react';

import Operator from '../../components/Operator';
import DataTable from '../../components/DataTable';
import EditDrawer from './EditDrawer';
import AvatarName from '../../components/AvatarName';
// import ImportButton from '../../components/ImportButton';
// import AddDataButton from '../../components/AddDataButton';
import SideNav from '../../components/SideNav';
import PageTransition from '../../components/PageTransition';

export default function Organization() {
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const dataTableRef = useRef(null);

  const reloadData = useCallback(() => {
    if (dataTableRef.current?.refresh) {
      dataTableRef.current.refresh();
    }
  }, []);

  const options = [
    { value: 'name', label: '机构姓名' },
    { value: 'contactName', label: '负责人' },
    { value: 'phone', label: '机构手机号' },
  ];

  const columns = [
    {
      title: '机构名称',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <AvatarName name={text} avatar={record.avatar} type="organization" />
      ),
    },
    {
      title: '负责人',
      dataIndex: 'contactName',
      key: 'contactName',
    },
    {
      title: '身份证号',
      dataIndex: 'idCard',
      key: 'idCard',
    },
    {
      title: '联系方式',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '所在城市',
      dataIndex: 'cityName',
      key: 'cityName',
    },
    {
      title: '操作',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <Operator
          removeAPI="/events/admin/leader"
          onRemove={reloadData}
          title="机构"
          record={record}
        />
      ),
    },
  ];

  return (
    <PageTransition>
      <SideNav />
      <main className="flex-1">
        <div className="bg-white rounded-xl shadow-sm p-6 space-y-5 container mx-auto">
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex justify-between gap-3 bg-slate-50 border border-slate-200 rounded-xl p-4 h-full">
                <div className="flex-1">
                  <p className="text-base font-semibold text-slate-900 text-left">
                    从平台库添加学校机构
                  </p>
                  <p className="text-xs text-slate-600 text-left">
                    直接从平台机构库挑选，快速添加学校机构
                  </p>
                </div>
                <AddDataButton
                  type="organization"
                  api="/events/admin/leader/list?isAllOrg=true"
                />
              </div>

              <div className="flex justify-between gap-3 bg-amber-50 border border-amber-200 rounded-xl p-4 h-full">
                <div className="flex-1">
                  <p className="text-base font-semibold text-slate-900 text-left">
                    导入学校机构
                  </p>
                  <div className="text-xs text-slate-700 text-left">
                    <span>
                      导入学校机构意味着您将学校机构加入平台机构库，平台将自动为学校机构创建一个小程序工作台。
                    </span>
                    <a
                      className="text-blue-400"
                      href="https://statics.dronex.cc/template/%E6%9C%BA%E6%9E%84%E6%A8%A1%E7%89%88.xlsx"
                    >
                      下载示例
                    </a>
                  </div>
                </div>
                <ImportButton
                  api="/events/admin/import/leader"
                  onSuccess={reloadData}
                />
              </div>
            </div> */}
          <DataTable
            ref={dataTableRef}
            options={options}
            onCreate={() => setEditDrawerVisible(true)}
            columns={columns}
            api="/events/admin/leader/list"
            // addType="organization"
          />
          <EditDrawer
            open={editDrawerVisible}
            onClose={() => {
              setEditDrawerVisible(false);
            }}
            onSave={reloadData}
          />
        </div>
      </main>
    </PageTransition>
  );
}
